import Icon from '../components/Icon.vue'

Icon.register({
  flushed: {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M344 200C330.7 200 320 210.7 320 224S330.7 248 344 248 368 237.3 368 224 357.3 200 344 200zM152 200C138.7 200 128 210.7 128 224S138.7 248 152 248 176 237.3 176 224 165.3 200 152 200zM248 8C111 8 0 119 0 256S111 504 248 504 496 393 496 256 385 8 248 8zM80 224C80 184.2 112.2 152 152 152S224 184.2 224 224 191.8 296 152 296 80 263.8 80 224zM312 400H184C162.8 400 162.8 368 184 368H312C333.2 368 333.2 400 312 400zM344 296C304.2 296 272 263.8 272 224S304.2 152 344 152 416 184.2 416 224 383.8 296 344 296z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/flushed.js
// module id = 6UGa
// module chunks = 144